import { createApi } from '@reduxjs/toolkit/query/react';
import { restBaseQuery } from '../../api/rest/baseQuery';
import { appConfiguration } from '../../configuration/appConfiguration';

export type PacePaymentPartners = 'DKV'; // we'll add more pace payment partners as we implement them

export type PaceOnboardingRequest = {
  cancelRedirectUrl: string;
  failureRedirectUrl: string;
  kind: PacePaymentPartners;
  metadata: object;
  proxy: boolean;
  successRedirectUrl: string;
  userId: string;
};

export type PaceOnboardingResponse = {
  data: {
    cancelRedirectUrl: string;
    cancelledAt: string | null;
    clientOnboardingUrl: string;
    completedAt: string | null;
    createdAt: string;
    expiresAt: string | null;
    failedAt: string | null;
    failureRedirectUrl: string;
    id: string;
    kind: string;
    metadata: object | null;
    proxy: boolean;
    status: 'PENDING' | 'COMPLETED' | 'FAILED' | 'CANCELLED' | string;
    successRedirectUrl: string;
    updatedAt: string;
    userId: string;
  };
};

export type PacePaymentMethodsResponse = {
  items: {
    id: string;
    label: PacePaymentPartners;
    name: string;
    expiresAt: string | null;
  }[];
};

export const paymentPartnersApiTemplateSlice = createApi({
  reducerPath: 'paymentPartnersApi',
  baseQuery: restBaseQuery(appConfiguration.simplepay.api.url),
  endpoints: (build) => ({
    paceOnboarding: build.query<PaceOnboardingResponse, PaceOnboardingRequest>({
      query: (body) => ({
        url: '/v1/pace/onboarding',
        method: 'POST',
        body,
      }),
    }),
    pacePaymentMethods: build.query<PacePaymentMethodsResponse, void>({
      query: () => ({
        url: '/v1/pace/cards',
        params: { enabled: true },
      }),
    }),
  }),
});

export const {
  reducer: paymentPartnerReducer,
  reducerPath: paymentPartnerReducerPath,
  middleware: paymentPartnerMiddleware,
  usePaceOnboardingQuery,
  usePacePaymentMethodsQuery,
} = paymentPartnersApiTemplateSlice;
